import { ColorantCellDraft } from '../types'
import { nextCellKey } from './next-cell-key'

export function toCellDrafts(
    colorants?: { colorant?: { documentId: string } | null; amount?: number | null }[]
): ColorantCellDraft[] {
    return (colorants ?? []).map(item => ({
        key: nextCellKey(),
        colorantDocumentId: item.colorant?.documentId ?? null,
        amount: item.amount,
    }))
}
